import { toUrl, buildUrl } from './url';
/**
 * Create a History API proxy to send signals to observers
 *
 * @param history - Inject a custom history compatible with with History
 * interface for testing or other purposes, if not provided, a global `history`
 * object will be used.
 * @param location - Inject a custom location object for testing purpose
 *
 * @returns BrowserHistory See {@link BrowserHistory}
 */
export const createHistory = (onRequestToChangeUrl, history = window.history, location = window.location) => {
    const back = () => {
        history.back();
    };
    const forward = () => {
        history.forward();
    };
    const refresh = () => {
        history.go();
    };
    const push = (urlOrLink, options) => {
        const url = toUrl(urlOrLink, options);
        // Signal url request before the execution
        onRequestToChangeUrl(url);
        // Internal Url
        if (url.isInternal()) {
            history.pushState(url.state, '', url.toInternalHref());
        }
        else {
            // External Url
            const href = url.toString();
            location.href = href;
        }
    };
    const replace = (urlOrLink, options) => {
        const url = toUrl(urlOrLink, options);
        // Signal url request before the execution
        onRequestToChangeUrl(url);
        // Internal Url
        if (url.isInternal()) {
            history.replaceState(url.state, '', url.toInternalHref());
        }
        else {
            // External Url
            const href = url.toString();
            location.replace(href);
        }
    };
    const replaceState = (key, value) => {
        const url = buildUrl(location.href, {
            state: { ...history.state, [key]: value },
        });
        // Signal url request before the execution
        onRequestToChangeUrl(url);
        // Only update the state of the current entry. Omitting the URL keeps
        // the current document URL, so this never navigates or redirects.
        history.replaceState(url.state, '');
    };
    return {
        get state() {
            return history.state;
        },
        back,
        forward,
        refresh,
        push,
        replace,
        replaceState,
    };
};
//# sourceMappingURL=history.js.map